/** Privacy / Terms / Disclaimer 法务页正文 */

const legalEffectiveDate = 'January 2026'

export const privacyPage = {
	title: 'Privacy Policy',
	effectiveDate: legalEffectiveDate,
	breadcrumb: [{ label: 'Home', href: '/' }, { label: 'Privacy Policy' }],
	relatedNav: [
		{ href: '/terms/', label: 'Terms of Service' },
		{ href: '/disclaimer/', label: 'Disclaimer' },
		{ href: '/dmca/', label: 'DMCA' },
	],
	sections: [
		{
			paragraphs: [
				'Your privacy matters when you browse GBWhatPro.org. This Privacy Policy describes what information we may collect when you visit our website, read guides, or follow download links—and how we use and protect that information. It applies to this domain only, not to WhatsApp, Meta, or third-party APK publishers.',
			],
		},
		{
			h2: 'Who operates this site',
			paragraphs: [
				'GBWhatPro.org is an independent English help site. We do not operate WhatsApp messaging services and do not receive your WhatsApp chat content through this website unless you voluntarily email us about a guide.',
			],
		},
		{
			h2: 'Information we collect',
			paragraphs: [
				'We may collect non-personal technical data such as browser type, device type, operating system, language preference, referring URL, and pages viewed. We use this to keep content readable, detect abuse, and understand which guides are most useful.',
				'If you contact us by email, we process the address, message body, and any attachments you send so we can respond. Do not email WhatsApp verification codes, account passwords, or government ID through our contact address.',
			],
			list: [
				'Server and CDN logs (IP address, request time, user agent) for security and performance',
				'Cookies or local storage used for basic site preferences or analytics, as described below',
				'Optional analytics events if enabled on this deployment (aggregated where possible)',
			],
		},
		{
			h2: 'How we use information',
			list: [
				'Provide, maintain, and improve articles, navigation, and download information',
				'Respond to corrections, privacy questions, and copyright notices',
				'Monitor traffic patterns, fix broken pages, and protect against automated abuse',
				'Comply with legal obligations when required by applicable law',
			],
		},
		{
			h2: 'Cookies and analytics',
			paragraphs: [
				'We may use cookies and similar technologies to remember preferences and to measure how visitors use the site. Third-party analytics providers may set their own cookies subject to their policies.',
				'You can block or delete cookies in your browser settings. Some features may work less smoothly if cookies are disabled.',
			],
		},
		{
			h2: 'APK downloads and file hosts',
			paragraphs: [
				'Download pages may link to APK files hosted on infrastructure we operate or on third-party CDNs. When you request a file, servers typically log IP address, timestamp, and user agent for delivery and security.',
				'Installing an APK is a separate action from browsing GBWhatPro.org. The modified app may request Android permissions and process data according to its own code—we do not control that behavior. Review permissions before install and read our <a href="/safety/malware-and-fake-apks/">fake APK guide</a>.',
			],
		},
		{
			h2: 'Third-party links',
			paragraphs: [
				'Guides may link to external websites, community forums, or app stores. We are not responsible for their privacy practices. Read their policies before submitting personal data elsewhere.',
			],
		},
		{
			h2: 'Data retention',
			paragraphs: [
				'We retain contact emails only as long as needed to resolve your request and for reasonable record-keeping. Server logs may be rotated or deleted on a schedule appropriate to security monitoring.',
			],
		},
		{
			h2: 'Your choices and rights',
			paragraphs: [
				'Depending on your region, you may have rights to access, correct, or delete personal data we hold about you. Email <a href="/contact/">contact</a> with “Privacy request” in the subject and enough detail for us to locate your message thread.',
				'We do not sell personal information as a business model. If that practice ever changes, we will update this page before doing so.',
			],
		},
		{
			h2: 'Children’s privacy',
			paragraphs: [
				'This site is not directed at children under 13. We do not knowingly collect personal information from children. If you believe a child contacted us, email us so we can delete the correspondence.',
			],
		},
		{
			h2: 'International visitors',
			paragraphs: [
				'Visitors may access GBWhatPro.org from many countries. Data may be processed on servers located outside your home jurisdiction. By using the site, you acknowledge that transfer may occur with appropriate safeguards where required.',
			],
		},
		{
			h2: 'Security',
			paragraphs: [
				'We use reasonable administrative and technical measures to protect information we hold. No internet transmission is completely secure; use email at your own discretion for sensitive topics unrelated to WhatsApp account access.',
			],
		},
		{
			h2: 'Changes to this policy',
			paragraphs: [
				'We may update this Privacy Policy. Revisions appear on this page with an updated effective date. Material changes may also be noted in site footer links when practical.',
			],
		},
		{
			h2: 'Contact',
			paragraphs: [
				'Privacy questions about GBWhatPro.org: use the email on our contact page (/contact/). For WhatsApp account issues, use official WhatsApp support channels—we cannot access your account.',
			],
		},
	],
}

export const termsPage = {
	title: 'Terms of Service',
	effectiveDate: legalEffectiveDate,
	breadcrumb: [{ label: 'Home', href: '/' }, { label: 'Terms of Service' }],
	relatedNav: [
		{ href: '/privacy-policy/', label: 'Privacy Policy' },
		{ href: '/disclaimer/', label: 'Disclaimer' },
		{ href: '/about/', label: 'About' },
	],
	sections: [
		{
			paragraphs: [
				'These Terms of Service (“Terms”) govern your access to GBWhatPro.org, its guides, and download resources. By using the site, you agree to these Terms. If you disagree, do not use the site.',
			],
		},
		{
			h2: 'Eligibility',
			paragraphs: [
				'You must be able to form a binding contract in your jurisdiction to use this site. If you are under the age required in your country, use the site only with a parent or guardian who accepts these Terms on your behalf.',
			],
		},
		{
			h2: 'Use of the website',
			paragraphs: [
				'You agree to use GBWhatPro.org lawfully and not to interfere with others’ use. Prohibited behavior includes attempting unauthorized access, scraping at rates that degrade service, uploading malware, or misrepresenting affiliation with WhatsApp or Meta.',
			],
			list: [
				'Do not use our contact email for spam, threats, or bulk automated messages',
				'Do not frame our pages to mislead users about the source of content',
				'Do not imply that GBWhatPro.org provides official WhatsApp support',
			],
		},
		{
			h2: 'Content and information',
			paragraphs: [
				'Guides are provided for general information only. APK menus, version numbers, and Android behavior change frequently. We strive for accuracy but do not warrant that every step matches your exact build.',
				'You are responsible for how you apply instructions—especially steps involving backups, uninstalls, or sideloading.',
			],
		},
		{
			h2: 'APK files and third-party applications',
			paragraphs: [
				'GB WhatsApp Pro and related mods are not developed or owned by GBWhatPro.org. They are not affiliated with Meta or WhatsApp LLC. Downloading or installing third-party software may violate WhatsApp’s terms, carry security risks, and lead to account restrictions.',
				'You install and use any APK entirely at your own risk. Verify file details on our <a href="/download/">download page</a> when available and read <a href="/safety/">safety information</a> first.',
			],
		},
		{
			h2: 'Intellectual property',
			paragraphs: [
				'Original text, layout, and branding on GBWhatPro.org are protected by applicable copyright laws. Trademarks such as WhatsApp belong to their owners and are used descriptively.',
				'You may link to our pages with a fair description. You may not republish large portions of our content without permission. Copyright complaints: see <a href="/dmca/">DMCA</a>.',
			],
		},
		{
			h2: 'User submissions',
			paragraphs: [
				'If you email suggestions or corrections, you grant us a non-exclusive license to use that feedback to improve the site without obligation to compensate you. Do not send confidential trade secrets unless you intend for us to use them for editorial review.',
			],
		},
		{
			h2: 'No warranties',
			paragraphs: [
				'The site and all content are provided “as is” and “as available” without warranties of any kind, express or implied, including merchantability, fitness for a particular purpose, and non-infringement.',
			],
		},
		{
			h2: 'Limitation of liability',
			paragraphs: [
				'To the fullest extent permitted by law, GBWhatPro.org and its operators are not liable for direct, indirect, incidental, consequential, or special damages arising from your use of the site, reliance on guides, download failures, data loss, account bans, or third-party applications.',
			],
		},
		{
			h2: 'Indemnification',
			paragraphs: [
				'You agree to indemnify and hold harmless GBWhatPro.org from claims arising out of your misuse of the site, your violation of these Terms, or your installation of third-party software linked from our pages, to the extent permitted by law.',
			],
		},
		{
			h2: 'External links',
			paragraphs: [
				'We are not responsible for external websites or download mirrors. Your use of third-party services is governed by their terms and policies.',
			],
		},
		{
			h2: 'Changes to these Terms',
			paragraphs: [
				'We may update these Terms. Continued use after the effective date of changes constitutes acceptance unless prohibited by applicable law.',
			],
		},
		{
			h2: 'Governing law and disputes',
			paragraphs: [
				'These Terms are governed by the laws applicable to the operator of GBWhatPro.org, without regard to conflict-of-law rules. Courts in that jurisdiction may have exclusive venue for disputes that cannot be resolved informally through <a href="/contact/">contact</a>.',
			],
		},
		{
			h2: 'Severability',
			paragraphs: [
				'If any provision of these Terms is held invalid, the remaining provisions remain in effect.',
			],
		},
		{
			h2: 'Contact',
			paragraphs: [
				'Questions about these Terms: email us via the contact page (/contact/).',
			],
		},
	],
}

export const disclaimerPage = {
	title: 'Disclaimer',
	effectiveDate: legalEffectiveDate,
	breadcrumb: [{ label: 'Home', href: '/' }, { label: 'Disclaimer' }],
	relatedNav: [
		{ href: '/terms/', label: 'Terms of Service' },
		{ href: '/privacy-policy/', label: 'Privacy Policy' },
		{ href: '/contact/', label: 'Contact' },
	],
	sections: [
		{
			paragraphs: [
				'Information on GBWhatPro.org is published in good faith for general educational purposes. We try to keep guides accurate, but we make no guarantee that any page is complete, current, or suitable for your device or jurisdiction.',
			],
		},
		{
			h2: 'No affiliation with WhatsApp or Meta',
			paragraphs: [
				'GBWhatPro.org is not affiliated with, endorsed by, or connected to WhatsApp, Meta Platforms, Inc., or their partners. Product names and logos belong to their respective owners and are used for identification only.',
			],
		},
		{
			h2: 'Third-party applications and APK files',
			paragraphs: [
				'Applications referenced on this site, including GB WhatsApp Pro builds, are developed by third parties. We do not control their code, updates, permissions, or data practices.',
				'Any download or installation is at your own risk. Scan files when appropriate, compare sizes with our <a href="/download/">download page</a>, and review Android permissions before tapping Install.',
			],
		},
		{
			h2: 'Account restrictions and data loss',
			paragraphs: [
				'Modified clients may violate WhatsApp terms and can lead to temporary or permanent account restrictions. GBWhatPro.org is not responsible for bans, lost chats, corrupted backups, or financial harm arising from use of unofficial software.',
				'For policy context, read <a href="/will-gb-whatsapp-get-you-banned/">ban risk</a> and <a href="/switch-from-gb-whatsapp-to-official-whatsapp/">switching to official WhatsApp</a>.',
			],
		},
		{
			h2: 'Security and malware',
			paragraphs: [
				'Fake or repackaged APKs exist on the wider internet. We describe red flags on <a href="/safety/malware-and-fake-apks/">malware and fake APKs</a>, but we cannot inspect every mirror you might encounter outside our domain.',
			],
		},
		{
			h2: 'External links',
			paragraphs: [
				'Links to other websites are provided for convenience. We do not monitor external content continuously. Follow external links at your own risk.',
			],
		},
		{
			h2: 'No professional advice',
			paragraphs: [
				'Articles are not legal, medical, financial, or IT security advice tailored to you. Consult qualified professionals for decisions that affect compliance, health, or regulated industries.',
			],
		},
		{
			h2: 'Editorial opinions',
			paragraphs: [
				'Comparisons between GB WhatsApp Pro and official WhatsApp reflect commonly reported user experiences and public policy statements, not insider knowledge of Meta product roadmaps.',
			],
		},
		{
			h2: 'Regional laws',
			paragraphs: [
				'Laws on software modification and sideloading vary by country. You are responsible for compliance with local rules when downloading or using APK files.',
			],
		},
		{
			h2: 'Consent',
			paragraphs: [
				'By using this website, you acknowledge this Disclaimer. If you do not agree, discontinue use of the site.',
			],
		},
		{
			h2: 'Updates',
			paragraphs: [
				'We may revise this Disclaimer. Changes appear on this page with an updated effective date.',
			],
		},
	],
}
